import { useHandler } from "@redotech/react-util/hook";
import { useTranslation } from "@redotech/redo-i18n";
import { StartState } from "@redotech/redo-return-ui/flows/start";
import {
  StepId,
  StepTypeDetailsProps,
} from "@redotech/redo-return-ui/flows/step";
import { Flex } from "@redotech/redo-web/flex";
import { Text } from "@redotech/redo-web/text";
import { memo } from "react";

export const StartDetails = memo(function Details({
  state,
  stepSelect,
  setState,
}: StepTypeDetailsProps<StartState>) {
  const { t } = useTranslation();
  const valueChange = useHandler((value: StepId | undefined) => {
    setState((state) => ({ ...state, next: value || undefined }));
  });

  return (
    <Flex dir="column" gap="xs">
      <Text fontSize="xs" fontWeight="medium" textColor="secondary">
        {t("Next step")}
      </Text>
      {stepSelect({ value: state.next, valueChange })}
    </Flex>
  );
});
